// External Libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import SelectBox from '../../components/ui/SelectBox';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { addCityFunc } from '../../../store/custom-actions/cities-actions/AddCitySlicer';
import { getCitiesFunc } from '../../../store/custom-actions/cities-actions/GetCitiesSlicer';
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';
import { getStatesFunc } from '../../../store/custom-actions/states-actions/GetStatesSlicer';


function NewCityForm({ show, onHide }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { register, reset, formState: { errors }, handleSubmit, watch } = useForm();
  const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const countryId = watch("country_id");

  const { data: countriesData, loading: getCountriesLoading } = useSelector(state => state.getCountriesSlicer);
  const { data: statesData, loading: getStatesLoading } = useSelector(state => state.getStatesSlicer);
  const { loading: submitLoading, apiErrors } = useSelector(state => state.addCitySlicer);

  useEffect(() => {
    dispatch(getCountriesFunc());
  }, []);

  useEffect(() => {
    if (countryId) {
      dispatch(getStatesFunc(`?country_id=${countryId}`));
    }
  }, [countryId]);

  useEffect(() => {
    countriesData && setCountriesList(countriesData);
  }, [countriesData]);

  useEffect(() => {
    statesData && setStatesList(statesData);
  }, [statesData]);

  const resetForm = () => {
    reset();
    onHide();
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    };

    const result = await dispatch(addCityFunc({ data: payload }));

    if (addCityFunc.fulfilled.match(result)) {
      dispatch(getCitiesFunc());
      resetForm();
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{t("New City")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-add"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormField
              label="Name"
              name="name"
              register={register}
              required={true}
              errors={errors}
            />

            <FormField
              label="Code"
              name="code"
              register={register}
              required={true}
              errors={errors}
            />
            <div className='mb-3'>
              <SelectBox
                label={t("Country")}
                showLabel={true}
                name="country_id"
                register={register}
                data={countriesList}
                loading={getCountriesLoading}
                placeholder={t("Choose Country")}
                required={true}
                errors={errors}
              />
            </div>
            <div className='mb-3'>
              <SelectBox
                label={t("State")}
                showLabel={true}
                name="state_id"
                register={register}
                data={statesList}
                loading={getStatesLoading}
                placeholder={t("Choose State")}
                required={true}
                errors={errors}
              />
            </div>
            <CheckboxField
              name="active"
              label="Activity"
              register={register}
              errors={errors}
              defaultChecked={true}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t("Close")}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-add"
          />
        </Modal.Footer>
      </Modal>
    </>
  );

}

export default NewCityForm;